// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseRolloutActionStatus } from './ResponseRolloutActionStatus';
import {
  ResponseRolloutActionStatusFromJSON,
  ResponseRolloutActionStatusFromJSONTyped,
  ResponseRolloutActionStatusToJSON,
  ResponseRolloutActionStatusToJSONTyped,
} from './ResponseRolloutActionStatus';

/**
 *
 * @export
 * @interface ResponseClusterRolloutAction
 */
export interface ResponseClusterRolloutAction {
  /**
   *
   * @type {number}
   * @memberof ResponseClusterRolloutAction
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterRolloutAction
   */
  requestedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterRolloutAction
   */
  requestedBy?: string;
  /**
   *
   * @type {ResponseRolloutActionStatus}
   * @memberof ResponseClusterRolloutAction
   */
  status?: ResponseRolloutActionStatus;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterRolloutAction
   */
  type?: string;
}

/**
 * Check if a given object implements the ResponseClusterRolloutAction interface.
 */
export function instanceOfResponseClusterRolloutAction(
  value: object,
): value is ResponseClusterRolloutAction {
  return true;
}

export function ResponseClusterRolloutActionFromJSON(
  json: any,
): ResponseClusterRolloutAction {
  return ResponseClusterRolloutActionFromJSONTyped(json, false);
}

export function ResponseClusterRolloutActionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseClusterRolloutAction {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    requestedAt: json['requestedAt'] == null ? undefined : json['requestedAt'],
    requestedBy: json['requestedBy'] == null ? undefined : json['requestedBy'],
    status:
      json['status'] == null
        ? undefined
        : ResponseRolloutActionStatusFromJSON(json['status']),
    type: json['type'] == null ? undefined : json['type'],
  };
}

export function ResponseClusterRolloutActionToJSON(
  json: any,
): ResponseClusterRolloutAction {
  return ResponseClusterRolloutActionToJSONTyped(json, false);
}

export function ResponseClusterRolloutActionToJSONTyped(
  value?: ResponseClusterRolloutAction | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    requestedAt: value['requestedAt'],
    requestedBy: value['requestedBy'],
    status: ResponseRolloutActionStatusToJSON(value['status']),
    type: value['type'],
  };
}
